import { Injectable } from '@angular/core';
import { IdentityToken } from '../data-access/auth-api.types';

const AuthStorageKey = 'rma.auth';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  private token: IdentityToken;

  storeToken(token: IdentityToken) {
    if (localStorage) {
      localStorage.setItem(AuthStorageKey, JSON.stringify(token));
    } else {
      this.token = token;
    }
  }

  retrieveToken(): IdentityToken | null {
    if (localStorage) {
      const token = localStorage.getItem(AuthStorageKey);

      return token && JSON.parse(token);
    } else {
      return this.token;
    }
  }

  clearToken() {
    localStorage?.removeItem(AuthStorageKey);
  }
}
